<template>
    <main class="CategoriaSeleccion-MAIN DISPLAY">
    <main class="INNER-MARGIN">

        <img src="../assets/MisPromos-logo.png"/>

        <div>
            <h2>Categorías</h2>
            <section class="section-categorias">
                <div v-for="(item, index) in categories" :key="index" @click="setCategory(item.id)">
                    <div :style="`background-color: ${item.color};`"><img :src="require(`../assets/${item.icon}`)"/></div>
                    <img :src="require(`../assets/${item.bg}`)">
                    <p>{{ item.name }}</p>
                </div>
            </section>
        </div>

        <!--<h2>Categorías</h2>
        <section class="section-categorias">
            <div><img src="../assets/circle-viajero.png" @click="setCategory(1)"/><p>Viajero</p></div>
            <div><img src="../assets/circle-estudiante.png" @click="setCategory(2)"/><p>Estudiante</p></div>
            <div><img src="../assets/circle-comida.png" @click="setCategory(3)"/><p>Comida</p></div>
            <div><img src="../assets/circle-mascotas.png" @click="setCategory(4)"/><p>Mascotas</p></div>
            <div><img src="../assets/circle-atleta.png" @click="setCategory(5)"/><p>Atleta</p></div>
            <div><img src="../assets/circle-tecnologico.png" @click="setCategory(6)"/><p>Tecnológico</p></div>
            <div><img src="../assets/circle-vida-familia.png" @click="setCategory(7)"/><p>Vida en Familia</p></div>
        </section>

        <h2>Momentos de Vida</h2>
        <section class="section-momentos-de-vida">
            <div><img src="../assets/circle-nuevo-hogar.png" @click="setCategory(8)"/><p>Nuevo hogar</p></div>
            <div><img src="../assets/circle-vida-pareja.png" @click="setCategory(9)"/><p>Vida en pareja</p></div>
            <div><img src="../assets/circle-nacimiento.png" @click="setCategory(10)"/><p>Nacimiento</p></div>
            <div><img src="../assets/circle-independencia.png" @click="setCategory(11)"/><p>Independencia</p></div>
        </section>-->

    </main>
    </main>
</template>

<script>
export default {
    name: 'CategoriaSeleccion',
    data(){
        return{
            categories: [
                {id: 11, color: "#EEFFE9", name: "Vida independiente", icon: "decease.png", bg: "min-cover-vida-independiente.png"},
                {id: 1, color: "#FFFAE2", name: "A la aventura", icon: "aeroplane.png", bg: "min-cover-a-la-aventura.png"},
                {id: 6, color: "#FFEEFE", name: "Mundo digital", icon: "business-inteligent.png", bg: "min-cover-vida-digital.png"},
                {id: 5, color: "#D4D1FC", name: "Mundo Fitness", icon: "bicycle.png", bg: "min-cover-fitness.png"},
                {id: 7, color: "#D7E8FC", name: "Vida en compañía", icon: "couple.png", bg: "min-cover-compania.png"},

                {id: 12, color: "#FCE677", name: "Detalles que inspiran", icon: "kids.png", bg: "min-cover-detalles.png"}, //faltan ids reales
                {id: 13, color: "#9FE38E", name: "Ecovibes", icon: "climate-action.png", bg: "min-cover-eco.png"}, //faltan ids reales
                {id: 14, color: "#92C8FB", name: "Cuida tu salud", icon: "insurance.png", bg: "min-cover-salud.png"}, //faltan ids reales
                {id: 3, color: "#4DCEC1", name: "Foodie", icon: "food-and-restaurant.png", bg: "min-cover-foodie.png"},
                {id: 2, color: "#FFB56B", name: "Estudiante", icon: "inclusive-growth.png", bg: "min-cover-estudiante.png"},
            ]
        }
    },
    methods: {
        getFrontURL(){
			return window.location.origin;
		},

        setCategory(detalle_){
            window.location.href = this.getFrontURL() + "/categoriadetalle/?categoria=" + detalle_;  
        }
    }
}
</script>

<style scoped lang="stylus">
.CategoriaSeleccion-MAIN
    background-color: #F5F9FF

.INNER-MARGIN
    display: flex
    flex-direction: column
    align-items: center

    >img
        width: 18vw
        max-width: 20ch
        margin-bottom: 5ch

.INNER-MARGIN > div
    background-color: white
    padding: 2ch
    border-radius: 2ch 
    box-shadow: 0 0 3ch rgba(0,0,0,0.1)
    max-width: 1080px

    >h2
        font-family: 'Benton Sans BBVA Medium'
        margin-top: 0
        margin-bottom: 2ch
        color: #001391
    
    >section
        display: grid
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr
        grid-gap: 3ch 2.5ch
        
        >div
            display: flex
            flex-direction: column
            align-items: center
            position: relative
            cursor: pointer

            >div
                display: flex
                align-items: center
                justify-content: center
                aspect-ratio: 1/1
                width: 3.3ch
                max-width: 3.3ch
                height: 3.3ch
                max-height: 3.3ch
                padding: 1ch
                border-radius: 100vw
                position: absolute
                top: -2ch
                right: 2.5ch

                img
                    max-width: 100%
                    max-height: 100%

            >img
                background-color: lightgray
                width: 100%
                aspect-ratio: 4/3
                border-radius: 1.5ch

            >p
                font-family: 'Benton Sans BBVA Medium'
                color: #001391
                text-align: center

/* RESPONSIVE */
@media all and (max-width:780px)

    .INNER-MARGIN > div > section
        grid-template-columns: 1fr 1fr
</style>